export { MiniState } from './state.class';
export { MiniStore } from './store.class';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/mini-ngrx/index.js
// module id = 764
// module chunks = 3